import { Ref, ref } from "vue";

export interface ToggleReturn {
  state: Ref<boolean>;
  toggleState: () => void;
}

export function useToggle(
  initialState: boolean,
  callback: ((newValue: boolean) => void) | null = null,
): ToggleReturn {
  const state = ref<boolean>(initialState);

  const toggleState = (): void => {
    state.value = !state.value;
    if (callback != null) {
      callback(state.value);
    }
  };

  return { state, toggleState };
}
